import React, {useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {getAnalysisModService, getAnalysisService} from "../../../services/app.service";
import {ANALYSIS_TYPES} from "../../../utils/constants";
import TextField from "@material-ui/core/TextField";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import Grid from "@material-ui/core/Grid";

function Level8CoverageComp(props) {

    const {application_id, reload} = props;

    const [analysis, setAnalysis] = useState({});
    const [loading, setLoading] = useState(false);

    async function fetchAnalysis() {
        try {
            setLoading(true);
            const result = await getAnalysisService(application_id, ANALYSIS_TYPES.LEVEL_8_COVERAGE);
            if(!result.error) {
                setAnalysis(result.data);
            }
            setLoading(false);
        }
        catch (e) {
            console.error(e);
            // already toasted the error
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAnalysis().then();
    }, [reload])

    return <>
        <br/>
        <TextField id='assumption1' variant="outlined" label={'Assumption: Count'} value={analysis.assumption1 || ""} InputProps={{readOnly: true}}/>
        <br/>
        <br/>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Level 8</TableCell>
                        <TableCell>Matching Count</TableCell>
                        <TableCell>Enough</TableCell>
                        {/*<TableCell>MB#</TableCell>*/}
                        <TableCell>Level 7</TableCell>
                        <TableCell>Level 5</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        analysis.data && analysis.data.map((item, index) =>
                           <TableRow>
                               <TableCell>{item.v3unit_no}</TableCell>
                               <TableCell>{item.unique_session_count}</TableCell>
                               <TableCell>{item.enough ? 'Yes' : 'No'}</TableCell>
                               {/*<TableCell>{item.mb_no}</TableCell>*/}
                               <TableCell>{item.v3dqco_no}</TableCell>
                               <TableCell>{item.v3dqc_no}</TableCell>
                           </TableRow>
                        )
                    }
                </TableBody>
            </Table>
            <LoaderWithBackDrop loading={loading}/>
        </TableContainer>

    </>
}

export default Level8CoverageComp;